<template>
  <div>
    <div class="blue-title">
      Search Results
    </div>
    <div class="mappables-container">
      <div v-if="waitingForResults">
        Searching...
      </div>
      <mappables-list
        v-else-if="filteredMappables.length"
        :mappables="filteredMappables"
        :onClick="onClick"
      >
      </mappables-list>
      <div v-else>
        No Matches.
      </div>
    </div>
  </div>
</template>

<script>
import MappablesList from './mappables-list';
export default {
  components: {
    MappablesList,
  },
  props: {
    filteredMappables: Array,
    onClick: Function,
  },
  computed: {
    waitingForResults() {
      return this.$store.state.map.executeSearch;
    },
  },
};
</script>

<style lang="scss" scoped>
.blue-title {
  margin-bottom: 1rem;
}

.mappables-container {
  height: 740px;
}
</style>
